import React, { useState, useEffect, useContext } from 'react';
import './UnitSummaryBar.css';
import baseApi from '../../common/api/base';
import LargeNumberIcon from '../LargeNumberIcon/LargeNumberIcon';
import DefaultMonitoredIndividualIcon from '../DefaultMonitoredIndividualIcon/DefaultMonitoredIndividualIcon';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import logComponent from '../../common/logComponent';

export default function UnitSummaryBar({ close }) {
  const environmentContext = useContext(EnvironmentContext);
  const [dataLoading, setDataLoading] = useState(false);
  const [dataError, setDataError] = useState(false);
  const [data, setData] = useState(null);
  const { hasToken, selectedUnit } = environmentContext;

  if (logComponent('UnitSummaryBar')) { console.debug('UnitSummaryBar rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('UnitSummaryBar')) { console.debug('UnitSummaryBar onMount'); }
    if (!hasToken) return;
  }, [])

  useEffect(() => {
    if (logComponent('UnitSummaryBar')) { console.debug('UnitSummaryBar useEffect [environmentContext.hasToken]'); }
    if (!hasToken) return;
    loadData();
  }, [environmentContext.hasToken])


  const loadData = () => {
    if (logComponent('UnitSummaryBar')) { console.debug('UnitSummaryBar loadData'); }
    if (!hasToken) return;

    setData(null);
    setDataLoading(true);
    setDataError(false);

    baseApi.Unit.GetSummaryForPastDays(selectedUnit.unitId, 7)
      .then(
        result => {
          let prevData = (data ? data : {});
          setData(Object.assign(prevData, result.data));
          setDataLoading(false);
          setDataError(false);
        },
        error => {
          setDataLoading(false);
          setDataError(true);
        }
      )
  }

  const getNotesCount = () => {
    if (logComponent('UnitSummaryBar')) { console.debug('UnitSummaryBar getNotesCount'); }
    if (!data || !data.recentNotes) return 0;

    return data.recentNotes.reduce((prev, curr) => {
      return prev + curr.Notes.length;
    }, 0);
  }


  return (
    <div className="Unit-Summary-Bar">
      <div className="Unit-Summary-Bar__monitoredindividual-info">
        <div className="Unit-Summary-Bar__monitoredindividual-image">
          {/* TODO: Replace with Monitored Individual image, if/when one becomes available */}
          <DefaultMonitoredIndividualIcon />
        </div>
        <p className="Unit-Summary-Bar__unit-name"> {selectedUnit.name}</p>
      </div>
      {
        data &&
        <div className="Unit-Summary-Bar__past-week">
          <p className="Unit-Summary-Bar__past-week-heading">This past week</p>
          <div className="Unit-Summary-Bar__past-week-content">
            <LargeNumberIcon number={data.checkInCount} text="Check-ins" />
            <LargeNumberIcon number={data.noteCount} text="Notes" />
            <LargeNumberIcon number={data.alarmsCount} text="Alarms" />
          </div>
        </div>
      }
    </div>
  );
}